<template>
  <div>
    <zm-drawer
      ref="drawer"
      :visible="visible"
      :width="width"
      :title="title"
      :footer="footer"
      @cancel="open(false)"
    >
      <div slot="drawerBody" class="relation_drawer">
        <zm-label title="备件信息" />
        <a-row class="basic_info" :gutter="20">
          <a-col :span="8">
            <a-form-item>
              <span class="info_label">备件名称</span>
              <span class="info_value">{{ model.name || 'xxxx' }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item>
              <span class="info_label">所属公司</span>
              <span class="info_value">{{ model.companyName || 'xxxx' }}</span>
            </a-form-item>
          </a-col>
        </a-row>

        <zm-label title="关联信息" />
        <div class="related">
          <a-row class="list" :gutter="20">
            <a-col :span="8" v-for="(item, index) in related.data" :key="index">
              <div class="item">
                <div class="item_name">{{ item.name }}[{{ item.number }}]</div>
                <a-divider type="vertical" />
                <a-icon type="close" @click="handleRemove(item, index)" />
              </div>
              
            </a-col>
          </a-row>
          <a-pagination
            class="related_pagination"
            size="small"
            :current="relatedPagination.current"
            :pageSize="relatedPagination.pageSize"
            :total="relatedPagination.total"
            @change="changePagination"
          />
        </div>

        <a-divider />
        <div class="table-search">
          <a-form layout="inline">
            <a-row :gutter="12" class="searchRow">
              <a-col :md="4" :sm="24" class="searchColInput">
                <a-input placeholder="请输入设备名称" v-model="searchModel.name" />
              </a-col>
              <a-col :md="4" :sm="24" class="searchColInput">
                <a-input placeholder="请输入设备编号" v-model="searchModel.number" />
              </a-col>
              <a-col :md="4" :sm="24" class="searchColInput">
                <a-input placeholder="请输入规格型号" v-model="searchModel.spec" />
              </a-col>
              <a-col :md="4" :sm="24" class="searchColBtn">
                <span class="table-page-search-submitButtons">
                  <a-button class="btn" type="primary" @click="search">查询</a-button>
                  <a-button class="btn" @click="clearSearch">重置</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-table
          bordered
          :pagination="equipPagination"
          :columns="equipments.columns"
          :rowKey="(record) => record.id"
          :dataSource="equipments.data"
          :loading="equipments.loading"
          @change="handleTableChange"
        >
          <template slot="actions" slot-scope="text, record">
            <a href="javascript:;" @click.stop="() => handleRelate(record)">关联</a>
          </template>
        </a-table>
      </div>
    </zm-drawer>
  </div>
</template>

<script>
import { getAssociatedDeviceData } from '@/api/sparePartsManagement'
export default {
  name: 'relationDrawer',
  data () {
    return {
      title: '关联设备',
      visible: false,
      width: window.innerWidth - 200,
      footer: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },

      model: {},
      related: {
        data: []
      },
      relatedPagination: {
        current: 1,
        pageSize: 9,
        total: 12
      },

      searchModel: {},
      equipments: {
        data: [],
        columns: [
          {
            title: '设备名称',
            dataIndex: 'name',
          },
          {
            title: '设备编号',
            dataIndex: 'number',
          },
          {
            title: '设备类别',
            dataIndex: 'c',
            width: 140
          },
          {
            title: '规格型号',
            dataIndex: 'd',
            width: 140
          },
          {
            title: '归口部门',
            dataIndex: 'e',
            width: 180
          },
          {
            title: '使用部门',
            dataIndex: 'f',
            width: 180
          },
          {
            title: '操作',
            scopedSlots: {
              customRender: 'actions'
            },
            width: 120
          }
        ],
        loading: false
      },
      equipPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        size: 'small',
        // showSizeChanger: true,
        // showQuickJumper: true
      }
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        this.initRelatedData()
        this.initEquipmentData()
      } else {
        this.model = {}
        this.$emit('refreshTable')
      }
    },
    initRelatedData () {
      const params = {
        current: this.relatedPagination.current,
        pageSize: this.relatedPagination.pageSize,
        id: this.model.id
      }
      // getAssociatedDeviceData(params).then(res => {
      //   if (res.status === 0) {
      //     this.related.data = res.data.list
      //     this.relatedPagination.total = res.data.total
      //   }
      // })
      this.related.data = [
        { name: '油漆漆膜盐雾试验箱1', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱2', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱3', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱4', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱5', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱6', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱7', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱8', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱9', number: '1010000022031124' },
      ]
      this.relatedPagination.total = 12
    },
    // 移除
    handleRemove (record, index) {
      this.related.data.splice(index, 1)
      // 调接口删除
      // 后调接口刷新
      // this.initRelatedData()
      // this.initEquipmentData()
    },
    changePagination (current, pageSize) {
      this.relatedPagination.current = current
      this.relatedPagination.pageSize = pageSize
      this.initRelatedData()
    },

    initEquipmentData () {
      const params = {
        current: this.equipPagination.current,
        pageSize: this.equipPagination.pageSize,
        id: this.model.id
      }
      // getAssociatedDeviceData(params).then(res => {
      //   if (res.status === 0) {
      //     this.related.data = res.data.list
      //     this.relatedPagination.total = res.data.total
      //   }
      // })
      this.equipments.data = [
        { name: '油漆漆膜盐雾试验箱1', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱2', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱3', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱4', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱5', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱6', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱7', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱8', number: '1010000022031124' },
        { name: '油漆漆膜盐雾试验箱9', number: '1010000022031124' },
      ]
      this.equipPagination.total = 12
    },
    handleTableChange (pagination) {
      this.equipPagination.current = pagination.current
      this.equipPagination.pageSize = pagination.pageSize
      this.initEquipmentData()
    },
    handleRelate (record) {
      // 调接口关联
      // 后调接口刷新
      // this.initRelatedData()
      // this.initEquipmentData()
    },
    search () {
      const model = { ...this.searchModel }
      if (model.name) {
        model.name = model.name.trim()
      }
      if (model.number) {
        model.number = model.number.trim()
      }
      for (var item in model) {
        if (!model[item]) {
          delete model[item]
        }
      }
      this.equipPagination.current = 1
      this.initEquipmentData()
    },
    clearSearch () {
      this.searchModel = {}
      this.equipPagination.current = 1
      this.initEquipmentData()
    },
    formClear () {
      this.related.data = []
      this.relatedPagination.current = 1
      this.relatedPagination.pageSize = 9
      this.relatedPagination.total = 0

      this.equipments.data = []
      this.equipPagination.current = 1
      this.equipPagination.pageSize = 10
      this.equipPagination.total = 0
    },
  }
}
</script>

<style lang="less" scoped>
.relation_drawer{
  .zm-label{
    margin-bottom: 8px;
  }
  .basic_info{
    .ant-form-item{
      margin-bottom: 10px;
    }
    .info_label{
      color: #B3B3B3;
      margin-right: 16px;
    }
  }
  .related{
    .list{
      margin-bottom: 10px;
      .item{
        display: flex;
        align-items: center;
        padding: 0 8px;
        height: 24px;
        line-height: 24px;
        background: #F3F9FF;
        border-radius: 3px;
        margin-bottom: 8px;
        .item_name{
          line-height: 18px;
          font-size: 12px;
          width: calc(100% - 32px);
        }
        .ant-divider{
          margin: 0 7px;
          background: #DDDDDD;
        }
        .anticon{
          vertical-align: middle;
          font-size: 16px;
          color: #E73B3B;
        }
      }
    }
    .related_pagination{
      text-align: center;
    }
  }
  .table-search{
    margin-bottom: 10px;
    .btn{
      margin-right: 10px;
    }
  }
  /deep/.ant-table-wrapper{
    .ant-table-pagination.ant-pagination{
      float: none;
      text-align: center;
    }
  }
}
</style>